module.exports = __webpack_public_path__ + "img/closure.f7d7abc1.svg";